module.exports = __webpack_public_path__ + "img/sad.aea9ddcb.png";